import React from 'react';
import { FadeIn } from './FadeIn';
import { TrophyIcon, ArrowUpRightIcon } from 'lucide-react';
export function PremiumUpsell() {
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-dark relative overflow-hidden" data-id="element-113">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-114" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-115">
        <FadeIn data-id="element-116">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-117">
            <TrophyIcon className="w-8 h-8 text-yellow-400" data-id="element-118" />
            <span className="text-yellow-400 font-bold tracking-widest uppercase" data-id="element-119">
              Para el coach que quiere ir un nivel más arriba
            </span>
          </div>

          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-10" data-id="element-120">
            Existe una versión del pack que incluye el{' '}
            <br className="hidden sm:block" data-id="element-121" />
            <span className="text-yellow-400" data-id="element-122">HYROX Business Accelerator.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-123">
          <div className="bg-gradient-to-br from-hyrox-surface to-hyrox-dark border border-yellow-500/20 p-8 sm:p-10 rounded-3xl shadow-2xl" data-id="element-124">
            <p className="text-lg text-gray-300 leading-relaxed mb-6" data-id="element-125">
              Y esa versión resuelve algo que los 6 tomos no resuelven solos:{' '}
              <strong data-id="element-126">
                la brecha entre ser un excelente coach técnico y tener un
                negocio que crece y que paga bien.
              </strong>
            </p>
            <p className="text-lg text-gray-300 leading-relaxed mb-8" data-id="element-127">
              Porque podés tener la mejor programación del mundo y seguir
              cobrando lo mismo que hace dos años. Podés tener alumnos que
              mejoran y seguir perdiéndolos porque no lo ven. Podés tener el
              mejor sistema técnico y seguir sin saber cómo diferenciarte de
              cualquier otro profe de funcional que "también hace HYROX".
            </p>

            <h3 className="text-2xl font-display font-bold text-white mb-6" data-id="element-128">
              El HYROX Business Accelerator cierra esas brechas.
            </h3>

            <ul className="space-y-4 mb-8" data-id="element-129">
              {['Te posiciona como el especialista HYROX de tu ciudad, no como un profe más.', 'Te da el sistema de captación que llena tus grupos sin depender del boca a boca.', 'Los scripts exactos para cada conversación de venta difícil.', 'El modelo de precios que justifica cobrar el doble con argumento real.', 'Y el sistema de retención que hace que tus alumnos se queden 12 meses.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-130">
                  <ArrowUpRightIcon className="w-6 h-6 text-yellow-400 shrink-0 mt-0.5" data-id="element-131" />
                  <span className="text-gray-300" data-id="element-132">{item}</span>
                </li>)}
            </ul>

            <div className="bg-yellow-500/10 border border-yellow-500/20 p-4 rounded-xl text-center" data-id="element-133">
              <p className="text-yellow-400 font-medium" data-id="element-134">
                No es para todos. Es para el coach que ya quiere que su
                conocimiento se convierta en un negocio real y rentable.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}